import Customer from "./To/Customer";
import Agent from "./To/MemberCard";
import Payments from "./Payment/multiple";
import Invoice from "./Invoice";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import TargetList from "./Picking/TargetList";
import Collapse from "../../../layout/Collapse";
import CheckBox from "../../../form/CheckBox";
import PartnerEditor from "../../../editors/partnerEditor";
import Icon from "../../../form/Icon";
import TillBasedPos from "./Pos/TillBasedPos";
import NewDefault from "./Buttons/NewDefault";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import ModalEditor from "../../ModalEditor";
import {CurrencyFormatter} from "../../../../utils/formatters";
import AddressControl from "../../../form/AddressControl";
import classNames from "classnames";
import Button from "../../../form/Button";
import connect from "react-redux/es/connect/connect";
import Box from "../../../layout/Box";
import {ProductList} from "./ChangePurchaseItem";
import {postData} from "../../../../utils/request";
import Modal from "../../../layout/Modal";
import Select from "../../../form/Select";
import List from "./List";
import {Tooltip} from "react-tippy";

export class ShopSalesForm extends React.Component {

    state = {
        usedvoucher: null
    }

    onSourceItemUpdate = async (item, oldItem, field) => {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        if (item.component_type === "Voucher") {
            if (item.sold) {
                if (!item.used) {
                    this.props.onVoucherItemUpdate(item);
                } else {
                    this.setState({
                        usedvoucher:
                            <Modal header="Beváltott utalvány!" state={"on"} ref={(el) => this.modal = el} size={"small"} {...props} disabled={props.disabled || props.isLoading} buttons={[
                                {
                                    text: "Rendben",
                                    props: {color: "danger", disabled: props.disabled || props.isLoading},
                                    onClick: async () => {
                                        this.setState({usedvoucher: null});
                                    }
                                }
                            ]}>
                                Ez az utalvány már be lett váltva!
                            </Modal>
                    });
                }
            } else {
                let actionparams = {
                    parentcomponent: props.componentConfig.componentname,
                    listfield: "items",
                    parentid: props.values[props.componentConfig.idfield]
                };

                let action = "addItemsToList";

                item.OperationList_id = props.values[props.componentConfig.idfield];

                actionparams = {
                    ...actionparams,
                    action: "componentlist." + action,
                    items: [item].map((item) => ({data: item}))
                };
                await postData(actionparams);
                let vouchers = [];
                if (Array.isArray(props.values.vouchers)) {
                    vouchers = JSON.parse(JSON.stringify(props.values.vouchers));
                }
                const index = vouchers.findIndex((voucher) => item.id + "" === "" + voucher.id);
                if (index === -1) {
                    vouchers.push(item);
                }
                props.setFieldValue("vouchers", vouchers);
            }
            this.vouchers && this.vouchers.refresh && this.vouchers.refresh();
            this.vatrates && this.vatrates.refresh && this.vatrates.refresh();
            parent.picklist && parent.picklist.target && parent.picklist.target.refresh();
        } else if(item.component_type !== "Voucher") {
            parent.onSourceItemUpdate(item, oldItem, field, 'addItemsToList');
            this.vatrates && this.vatrates.refresh && this.vatrates.refresh();
            this.vouchers && this.vouchers.refresh && this.vouchers.refresh();
        }
    }

    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, pool, operationitems, actionButtons, componentConfig} = props;
        const Editor = props.editor || BoxEditor;
        if (!(this.props.till || {}).id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy kasszába!
            </Box>;
        }
        /*componentProps.props.operationitems.columns.discount.aggregation = () => {
            return <div className="pull-right">
                <Tooltip title="Kosár kedvezmény automatikus számolása">
                    <CheckBox
                        name={"xtradata.calculateGroupDiscount"}
                        value={(props.values.xtradata || {}).calculateGroupDiscount}
                        onIcon={{lib: "fas", name: "shopping-basket"}}
                        offIcon={{lib: "fas", name: "shopping-basket"}}
                        saveChanges={props.setFieldValue}
                    />
                </Tooltip>
            </div>;
        }*/

        const vats = {};
        const swap = (props.values.payments || []).find((v) => v.serviceprovider_type === "SwapPayment");
        ((swap || {}).purchaseitems || []).map((item) => {
            vats[item.vat.id] = (vats[item.vat.id] || 0) + (parseFloat(item.saleprice) * parseFloat(item.qty));
        });
        let voucherAmount = 0;
        let voucherVats = {};
        const voucher = (props.values.payments || []).find((v) => v.serviceprovider_type === "VoucherPayment");
        ((voucher || {}).vouchers || []).map((voucher) => {
            voucherAmount += parseFloat(voucher.amount || voucher.saleprice);
            voucherVats[voucher.vat.id] = vats[voucher.vat.id] = (vats[voucher.vat.id] || 0) + parseFloat(voucher.amount || voucher.saleprice);
        });

        return <Fragment>
            {props.closing && <List boxid={props.componentEditor + "ListBox"} {...componentProps} />}
            <Editor
                theme="default"
                footer={<Fragment>
                    {Array.isArray(actionButtons) ? actionButtons.map((i) => i) : actionButtons}
                    <NewDefault {...componentProps} otherSide="pull-right" />
                </Fragment>}
            >
                {this.state.usedvoucher}
                <Modal header="Készlethiány!" ref={(el) => this.modal = el} size={"small"} {...props} disabled={props.disabled || props.isLoading} buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: props.disabled || props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            try {
                                this.hide();
                            } catch (e) {

                            }
                        }
                    },
                    {
                        text: "Rendben",
                        props: {color: "primary", disabled: props.disabled || props.isLoading},
                        onClick: async () => {
                            try {
                                this.hide();
                            } catch (e) {

                            }
                        }
                    }
                ]}>
                </Modal>
                {
                    props.values[props.componentConfig.idfield] && <form onSubmit={props.handleSubmit}>
                        <div className="row hidden">
                            <TillBasedPos {...componentProps} />
                        </div>
                        <div className="row form-row">
                            <div className="col-md-8">
                                <Agent {...componentProps} />
                            </div>
                            <div className="col-md-4">
                                <Select
                                    label="Kupon(ok)"
                                    component="discount"
                                    name="coupons"
                                    labelKey="promo_code"
                                    valueKey="id"
                                    autoSelect={true}
                                    value={props.values.coupons}
                                    isMulti={true}
                                    openIfHasOptions={true}
                                    filter={[
                                        {field: "promotion.pos", systemvalue: "Context.pos"},
                                        {field: "promotion.active", value: 1}
                                    ]}
                                    {...props.getProps("coupons")}
                                    saveChanges={props.setFieldValue}
                                />
                            </div>
                        </div>
                        <TargetList {...componentProps} onSourceItemUpdate={this.onSourceItemUpdate} />
                        {((swap || {}).purchaseitems || []).length ? <Fragment>
                            <label className="control-label">Csere tételek</label>
                            <ProductList purchaseitems={((swap || {}).purchaseitems || [])} onItemUpdate={this.props.onItemUpdate} />
                        </Fragment> : null}
                        <div className="row form-row">
                            <div className="col-md-12">
                                <CheckBox name={"xtradata.createinvoice"} value={(props.values.xtradata || {}).createinvoice}
                                          label={<span><Icon lib="fa" name="file"/> Számlázás</span>}
                                          saveChanges={props.setFieldValue}/>
                                <Collapse collapsed={!!parseInt((props.values.xtradata || {}).createinvoice)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className={classNames({
                                                    "col-md-9": props.values.customer,
                                                    "col-md-11": !props.values.customer
                                                })}>
                                                    <div className="row">
                                                        <div className={classNames({
                                                            "col-md-3": props.values.customer,
                                                            "col-md-12": !props.values.customer
                                                        })}>
                                                            <Customer
                                                                {...componentProps}
                                                                props={{
                                                                    ...componentProps.props,
                                                                    labels: {
                                                                        ...componentProps.props.labels,
                                                                        customer: "Partner"
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        {props.values.customer &&
                                                        <div className={"col-md-9"}>
                                                            <div className={"row"}>
                                                                <AddressControl
                                                                    disabled={"disabled"}
                                                                    value={props.values.customer.address}
                                                                    label="Cím"
                                                                />
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="row">
                                                        <label className="control-label">&nbsp;</label>
                                                        <PartnerEditor
                                                            inline={true}
                                                            ref={(partnerForm) => this.partnerForm = partnerForm}
                                                            editor={ModalEditor}
                                                            selection={null}
                                                            list={(props) => {
                                                                return props.footer;
                                                            }}
                                                            saveForm={async (data, componentConfig, editorProps) => {
                                                                props.setFieldValue("customer", data);
                                                                await editorProps.setFormValues({});
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {props.values.customer && <Fragment>
                                                    <div className="col-md-1">
                                                        <label className="control-label">&nbsp;</label>
                                                        <Button
                                                            icon={{lib: "fas", name: "pencil-alt"}}
                                                            block={true}
                                                            color="default"
                                                            onClick={() => {
                                                                props.setContent("partner", {partner_id: props.values.customer.partner_id});
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-1">
                                                        <label className="control-label">&nbsp;</label>
                                                        <Button
                                                            icon={{lib: "fa", name: "times"}}
                                                            tooltip="Mégse"
                                                            block={true}
                                                            color="danger"
                                                            onClick={() => {
                                                                props.setFieldValue("customer", null);
                                                            }}
                                                        />
                                                    </div>
                                                </Fragment>}
                                            </div>
                                        </div>
                                    </div>
                                    <Invoice {...componentProps} />
                                </Collapse>
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-3">
                                <div className="row form-row">
                                    <Payments {...componentProps} props={{...componentProps.props, providerTheme: "radio", ...this.props.getPrices()}}/>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <SelectorGrid
                                    {...operationitems}
                                    ref={(vatrates) => this.vatrates = vatrates}
                                    emptyMessage={""}
                                    reqparams={{...(operationitems.reqparams || {}), _: props.refresh}}
                                    className={"shopsales-vat-aggregation"}
                                    pageSize={-1}
                                    exports={[]}
                                    orderBy={{field: "vat.name", direction: "ASC"}}
                                    showVisibleColumnFilter={false}
                                    view={["saleprice", "vat.name", "vat.id"]}
                                    actions={false}
                                    onLoadCompleted={(response) => {
                                        //let voucherAmountSum = voucherAmount;
                                        let total = 0;
                                        let cost = 0;
                                        if (response.aggregations && response.aggregations.length) {
                                            response.aggregations.map((row) => {
                                                total += parseFloat(row.total || "0");
                                                cost += parseFloat(row.cost || "0");
                                                if (voucherVats[row.vat.id]) {
                                                    voucherAmount -= voucherVats[row.vat.id];
                                                }
                                            });
                                            /*if (voucherAmount > 0) {
                                                response.aggregations = response.aggregations.map((row) => {
                                                    if (voucherAmount >= cost) {
                                                        row.cost = 0;
                                                    } else {
                                                        voucherAmountSum -= row.cost;
                                                        if (voucherAmountSum > 0) {
                                                            row.cost = voucherAmountSum;
                                                        } else {
                                                            const abs = -1 * voucherAmountSum;
                                                            if (abs < row.cost) {
                                                                row.cost = abs;
                                                            }
                                                        }
                                                    }
                                                    return row;
                                                });
                                            }*/
                                        }
                                        this.props.setStateFields({total});
                                        return response;
                                    }}
                                    columns={{
                                        "vat.name": {
                                            header: "Gyűjtő",
                                            width: 1,
                                            aggregation: (value, row) => {
                                                return value;
                                            }
                                        },
                                        "cost": {
                                            header: "Összeg",
                                            width: 1,
                                            columnClassName: (field, value, rowData) => {
                                                return {
                                                    "currency": true,
                                                    "danger color": parseFloat(rowData.saleprice) < 0,
                                                }
                                            },
                                            renderer: CurrencyFormatter,
                                            className: "currency",
                                        }
                                    }}
                                    aggregations={{
                                        fields: {
                                            "cost": {
                                                expression: "SUM({{saleprice}} * {{qty}})" + (Object.keys(vats).length ? " - CASE " + Object.keys(vats).map((vat) => "WHEN {{vat.id}} = " + String(vat) + " THEN " + String(vats[vat] || 0)).join(" ") + " ELSE 0 END" : ""),
                                            },
                                            "total": {
                                                expression: "SUM({{saleprice}} * {{qty}})",
                                            },
                                            "vat.name": {
                                                field: "vat.name", type: ""
                                            },
                                        },
                                        by: ["vat.name"]
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                }
            </Editor>
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(ShopSalesForm);